import { formatMoney, invoiceStatusLabel, invoiceStatusClass } from '../../lib/billing-format.js';
import { formatDate } from '../../lib/names.js';

/**
 * InvoiceRow — single row in the invoice history table.
 *
 * Shows: date, invoice number, status pill, amount, and actions
 * (View in Stripe, Download PDF).
 *
 * View/Download links go directly to Stripe-hosted URLs — no backend
 * proxy needed. hosted_invoice_url is a customer portal-style page,
 * invoice_pdf is a pre-signed PDF URL (~30 day expiry).
 */
export function InvoiceRow({ invoice }) {
  const created = invoice.created_at || invoice.period_end || null;
  return (
    <tr>
      <td>{formatDate(created)}</td>
      <td style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--fs-xs)' }}>
        {invoice.number || invoice.id}
      </td>
      <td>
        <span className={`inv-status ${invoiceStatusClass(invoice.status)}`}>
          {invoiceStatusLabel(invoice.status)}
        </span>
      </td>
      <td style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 500 }}>
        {formatMoney(invoice.total_pence)}
      </td>
      <td>
        <div className="invoice-actions">
          {invoice.hosted_invoice_url && (
            <a
              href={invoice.hosted_invoice_url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost"
              style={{ fontSize: 'var(--fs-xs)', padding: '0.25rem 0.5rem' }}
            >
              View
            </a>
          )}
          {invoice.invoice_pdf && (
            <a
              href={invoice.invoice_pdf}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost"
              style={{ fontSize: 'var(--fs-xs)', padding: '0.25rem 0.5rem' }}
            >
              PDF
            </a>
          )}
        </div>
      </td>
    </tr>
  );
}
